import { GitBranch, Play, TrendingUp, AlertTriangle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { ComingSoonWatermark } from '@/components/ComingSoonWatermark';
import { useNavigation } from '@/contexts/NavigationContext';
import { cn } from '@/lib/utils';

export function ScenariosPage() {
  const { sectionColor } = useNavigation();

  return (
    <div className="space-y-6">
      <ComingSoonWatermark
        pageKey="risk-scenarios"
        icon={GitBranch}
        title="Risk Scenario Modeling Coming Soon"
        description="Advanced risk scenario modeling with Monte Carlo simulation, stress testing, and what-if analysis will be available soon."
      />
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className={cn("text-3xl font-bold", sectionColor)}>Risk Scenarios</h1>
          <p className="text-neutral-400 mt-1">
            Model and simulate risk scenarios for stress testing
          </p>
        </div>
        <button className="btn-primary">
          Create Scenario
        </button>
      </div>

      {/* Metrics Strip */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Total Scenarios</p>
              <p className="text-2xl font-bold text-white mt-1">24</p>
            </div>
            <div className="p-3 bg-primary-500/20 rounded-lg">
              <GitBranch className="text-primary-400" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Simulations Run</p>
              <p className="text-2xl font-bold text-white mt-1">87</p>
            </div>
            <div className="p-3 bg-primary-500/20 rounded-lg">
              <Play className="text-primary-400" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">High Severity</p>
              <p className="text-2xl font-bold text-danger-500 mt-1">8</p>
            </div>
            <div className="p-3 bg-danger-500/20 rounded-lg">
              <AlertTriangle className="text-danger-500" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Avg Impact Score</p>
              <p className="text-2xl font-bold text-warning-500 mt-1">67</p>
            </div>
            <div className="p-3 bg-warning-500/20 rounded-lg">
              <TrendingUp className="text-warning-500" size={24} />
            </div>
          </div>
        </Card>
      </div>

      {/* Scenarios Table */}
      <Card className="p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Risk Scenarios</h3>
        <div className="space-y-3">
          <div className="p-4 bg-neutral-900/50 border border-neutral-800 rounded-lg hover:border-primary-500/30">
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-white font-medium">Cyber Attack on Payment Systems</h4>
              <span className="badge-danger">High Severity</span>
            </div>
            <p className="text-sm text-neutral-400 mb-3">Simulates a coordinated cyber attack targeting payment processing infrastructure</p>
            <div className="grid grid-cols-3 gap-4 text-sm">
              <div><span className="text-neutral-500">Probability:</span> <span className="text-warning-400">68%</span></div>
              <div><span className="text-neutral-500">Impact:</span> <span className="text-danger-400">Critical</span></div>
              <div><span className="text-neutral-500">Simulations:</span> <span className="text-neutral-300">12</span></div>
            </div>
          </div>
          <div className="p-4 bg-neutral-900/50 border border-neutral-800 rounded-lg hover:border-primary-500/30">
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-white font-medium">Regulatory Framework Changes</h4>
              <span className="badge-warning">Medium Severity</span>
            </div>
            <p className="text-sm text-neutral-400 mb-3">Models impact of sudden regulatory requirement changes</p>
            <div className="grid grid-cols-3 gap-4 text-sm">
              <div><span className="text-neutral-500">Probability:</span> <span className="text-primary-400">45%</span></div>
              <div><span className="text-neutral-500">Impact:</span> <span className="text-warning-400">High</span></div>
              <div><span className="text-neutral-500">Simulations:</span> <span className="text-neutral-300">8</span></div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
